import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'flow-info-note',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './info-note.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoNoteComponent {
  @Input() label: string;
}
